import React from 'react'
import "./About_Banner.css"

const About_Banner = ({ banner, name }) => {
  return (
    <section className='About_Banner'>
      <div className='container-fluid'>
        <div className='About_Banner_holder'>
          <div className='banner_holder'>
            <img src={banner} className='banner' />
            {/* <img src='/assets/images/about-us/about_banner.png' className='banner' /> */}
          </div>

          <div className='name_holder'>
            <h5 className='about_us'>{name || "About Us"}</h5>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About_Banner